import { takeLatest, call, select, put } from 'redux-saga/effects';
import { applyAdjustment } from 'yoda-interfaces/lib/Order/OrderApi';
import get from 'lodash/get';
import {
    APPLY_VENDOR_COUPON,
    APPLY_VENDOR_COUPON_ERROR,
} from '../actionTypes/OtherVendorActionTypes';
import { selectPreferences } from '../selectors/ContextSelector';
import FactorySaga from './FactorySaga';

function* applyCoupon(data) {
    const preferences = yield select(selectPreferences);
    const count = preferences.merticalCouponRetryLogicCount || 0;
    for (let i = 0; i < count + 1; i += 1) {
        const adjustmentResponse = yield call(FactorySaga, applyAdjustment, data);
        const statusCode = get(adjustmentResponse, 'response.status', '');
        if (adjustmentResponse.isSuccess) {
            return { status: adjustmentResponse.isSuccess };
        }
        if (!(statusCode > 499 && statusCode < 600)) {
            return { status: false };
        }
    }
    return { status: false };
}

export function* applyVendorAdjustmentsSaga(action) {
    try {
        const response = yield call(applyCoupon, {
            payload: { ...action.payload },
            type: action.type,
        });
        action.callback(response.status);
    } catch (error) {
        yield put({ type: APPLY_VENDOR_COUPON_ERROR, error });
    }
}

function* watchVendorActionsSaga() {
    yield takeLatest(APPLY_VENDOR_COUPON, applyVendorAdjustmentsSaga);
}

watchVendorActionsSaga.sagaName = 'watchVendorActionsSaga';

export default watchVendorActionsSaga;
